// extracted by mini-css-extract-plugin
export default {"foundation":"Home_foundation__QrrD0"};